import React, { useState } from "react"
import { Select } from "antd"
import { useRequest } from "ahooks"
import { searchProjectsApi, type ProjectSearchOption } from "@/services/apis/project"

/**
 * 项目搜索下拉框（未签约复盘「选正确项目 / 关联项目」）
 * 按关键字远程搜索（防抖 300ms），数据源 GET /workbenchApi/projects/search，
 * 选项展示「项目编号 + 项目名称」（value 为项目编号）。
 */
const ProjectSearchSelect: React.FC<{
    value?: string
    onChange: (v?: string) => void
    placeholder?: string
    allowClear?: boolean
    className?: string
}> = ({ value, onChange, placeholder, allowClear, className }) => {
    const [options, setOptions] = useState<ProjectSearchOption[]>([])

    const { run: search, loading } = useRequest(searchProjectsApi, {
        manual: true,
        debounceWait: 300,
        onSuccess: (data) => setOptions(data ?? []),
    })

    return (
        <Select
            className={className}
            placeholder={placeholder}
            showSearch
            allowClear={allowClear}
            filterOption={false}
            loading={loading}
            value={value}
            options={options}
            onSearch={(kw) => {
                const keyword = kw.trim()
                if (keyword) {
                    search(keyword)
                } else {
                    setOptions([])
                }
            }}
            onChange={(v) => onChange(v)}
        />
    )
}

export default ProjectSearchSelect
